module.exports = __webpack_public_path__ + "static/media/LosMonstruosBookCover.7bd93dc4.jpg";